{
  "en": {
    "tableOnScreen": "There is a table on screen.",
    "codeOnScreen": "There is code on screen.",
    "linkOnScreen": "There is a link on screen."
  },
  "bg": {
    "tableOnScreen": "На екрана има таблица.",
    "codeOnScreen": "На екрана има код.",
    "linkOnScreen": "На екрана има връзка."
  },
  "hr": {
    "tableOnScreen": "Na zaslonu je tablica.",
    "codeOnScreen": "Na zaslonu je kôd.",
    "linkOnScreen": "Na zaslonu je poveznica."
  },
  "cs": {
    "tableOnScreen": "Na obrazovce je tabulka.",
    "codeOnScreen": "Na obrazovce je kód.",
    "linkOnScreen": "Na obrazovce je odkaz."
  },
  "da": {
    "tableOnScreen": "Der er en tabel på skærmen.",
    "codeOnScreen": "Der er kode på skærmen.",
    "linkOnScreen": "Der er et link på skærmen."
  },
  "nl": {
    "tableOnScreen": "Er staat een tabel op het scherm.",
    "codeOnScreen": "Er staat code op het scherm.",
    "linkOnScreen": "Er staat een link op het scherm."
  },
  "et": {
    "tableOnScreen": "Ekraanil on tabel.",
    "codeOnScreen": "Ekraanil on kood.",
    "linkOnScreen": "Ekraanil on link."
  },
  "fi": {
    "tableOnScreen": "Ruudulla on taulukko.",
    "codeOnScreen": "Ruudulla on koodia.",
    "linkOnScreen": "Ruudulla on linkki."
  },
  "fr": {
    "tableOnScreen": "Un tableau est affiché à l’écran.",
    "codeOnScreen": "Du code est affiché à l’écran.",
    "linkOnScreen": "Un lien est affiché à l’écran."
  },
  "de": {
    "tableOnScreen": "Auf dem Bildschirm ist eine Tabelle.",
    "codeOnScreen": "Auf dem Bildschirm ist Code.",
    "linkOnScreen": "Auf dem Bildschirm ist ein Link."
  },
  "el": {
    "tableOnScreen": "Υπάρχει πίνακας στην οθόνη.",
    "codeOnScreen": "Υπάρχει κώδικας στην οθόνη.",
    "linkOnScreen": "Υπάρχει σύνδεσμος στην οθόνη."
  },
  "hu": {
    "tableOnScreen": "A képernyőn egy táblázat látható.",
    "codeOnScreen": "A képernyőn kód látható.",
    "linkOnScreen": "Egy hivatkozás látható a képernyőn."
  },
  "ga": {
    "tableOnScreen": "Tá tábla ar an scáileán.",
    "codeOnScreen": "Tá cód ar an scáileán.",
    "linkOnScreen": "Tá nasc ar an scáileán."
  },
  "it": {
    "tableOnScreen": "Sullo schermo c’è una tabella.",
    "codeOnScreen": "Sullo schermo c’è del codice.",
    "linkOnScreen": "Sullo schermo c’è un collegamento."
  },
  "lv": {
    "tableOnScreen": "Ekrānā ir tabula.",
    "codeOnScreen": "Ekrānā ir kods.",
    "linkOnScreen": "Ekrānā ir saite."
  },
  "lt": {
    "tableOnScreen": "Ekrane yra lentelė.",
    "codeOnScreen": "Ekrane yra kodo.",
    "linkOnScreen": "Ekrane yra nuoroda."
  },
  "mt": {
    "tableOnScreen": "Hemm tabella fuq l-iskrin.",
    "codeOnScreen": "Hemm kodiċi fuq l-iskrin.",
    "linkOnScreen": "Hemm link fuq l-iskrin."
  },
  "pl": {
    "tableOnScreen": "Na ekranie jest tabela.",
    "codeOnScreen": "Na ekranie jest kod.",
    "linkOnScreen": "Na ekranie jest link."
  },
  "pt": {
    "tableOnScreen": "Há uma tabela no ecrã.",
    "codeOnScreen": "Há código no ecrã.",
    "linkOnScreen": "Há uma ligação no ecrã."
  },
  "ro": {
    "tableOnScreen": "Pe ecran este un tabel.",
    "codeOnScreen": "Pe ecran este cod.",
    "linkOnScreen": "Pe ecran este un link."
  },
  "sk": {
    "tableOnScreen": "Na obrazovke je tabuľka.",
    "codeOnScreen": "Na obrazovke je kód.",
    "linkOnScreen": "Na obrazovke je odkaz."
  },
  "sl": {
    "tableOnScreen": "Na zaslonu je tabela.",
    "codeOnScreen": "Na zaslonu je koda.",
    "linkOnScreen": "Na zaslonu je povezava."
  },
  "es": {
    "tableOnScreen": "Hay una tabla en pantalla.",
    "codeOnScreen": "Hay código en pantalla.",
    "linkOnScreen": "Hay un enlace en pantalla."
  },
  "sv": {
    "tableOnScreen": "Det finns en tabell på skärmen.",
    "codeOnScreen": "Det finns kod på skärmen.",
    "linkOnScreen": "Det finns en länk på skärmen."
  }
}
